import { iSubRoute } from "../../../definitions/interfaces"

export function getARTargetRoutes({ urlPrefix = "" }) {
  return routes.map((r) => ({ ...r, route: urlPrefix + r.route }))
}

const routes: iSubRoute[] = [
  {
    title: "Overview",
    route: "",
  },
  {
    title: "Uploads",
    route: "/manage-files",
  },
]
